<div class="mdiv scrollable-element text-grey">
  <div class="main-left w-70 h-100 p-3">
    <div class="hide-scrollbar"></div>
    <img src="../../../assets/images/syncious/hpc_infra.png"
         alt="img"
         class="img" />
  </div>
  <div class="d-flex justify-content-center align-items-center">
    <div class="card text-center p-4 shadow" style="max-width: 400px; width: 100%;">
      <div class="card-body">
        <h4 class="card-title text-danger mb-3">You have been logged out</h4>
        <p class="card-text text-muted">Your session has ended. Please log in again to continue.</p>
        <!--<a href="/Home" class="btn btn-primary mt-3 w-100">Login</a>-->
      </div>
    </div>
  </div>
</div>
